// extracted by mini-css-extract-plugin
export var copyableField = "_q3-4";
export var customerBadge = "_q3-0";
export var customerInfoTitle = "_q3-2";
export var details = "_q3-1";
export var dropdownContainer = "_q3-5";
export var dropdownImage = "_q3-6";
export var editAssigneeForm = "_q3-a";
export var editButton = "_q3-3";
export var email = "_q3-7";
export var hidden = "_q3-d";
export var input = "_q3-8";
export var saveButton = "_q3-b";
export var shopifyIcon = "_q3-c";
export var suggestionBadge = "_q3-e";
export var suggestionText = "_q3-f";
export var username = "_q3-9";